import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { TextAreaPage } from '../../../../shared/pages/TextAreaPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryTextAreaRef } from '../../../../shared/types/toolTypes'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { getCleanValue } from '../../../../shared/utils/getCleanValue'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { validateCharCount } from '../../../../shared/utils/validateCharCount'
import { SellerContactFlow, WhatHappenedFlow } from '../../pageFlowData'
import { whatHappenedData } from './data'
import styles from './WhatHappened.module.scss'

export const WhatHappened: FunctionComponent = () => {
  const { imgObj, title, placeholderText, descriptiveText } = whatHappenedData
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    issue: { description },
  } = state

  const [WhatHappenedTextAreaValid, setWhatHappenedTextAreaValid] = useState<boolean>(true)
  const WhatHappenedTextAreaRef = useRef<FormEntryTextAreaRef>(null)

  const handleWhatHappenedChange = () => {
    const value = getCleanValue(WhatHappenedTextAreaRef.current?.formEntryTextarea?.value)
    dispatch({ type: 'UPDATE_ISSUE_DESCRIPTION', data: value })
  }

  const handleDispatch = () => {
    dispatch({ type: 'UPDATE_STEP', data: SellerContactFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: SellerContactFlow.PROGRESS_VALUE })
  }

  const handleTracking = () => {
    const trackingAnswer = `question | ${WhatHappenedFlow.VIEW_NAME} | PII`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleWhatHappenedSubmit = () => {
    const value: string = getCleanValue(WhatHappenedTextAreaRef.current?.formEntryTextarea?.value)
    const isValid: boolean = validateCharCount(value.length, 2500)
    const isEmpty = !isNotEmpty(value)

    if (!isValid || isEmpty) {
      setWhatHappenedTextAreaValid(false)
      return
    }

    setWhatHappenedTextAreaValid(true)
    handleTracking()
    handleDispatch()
  }

  return (
    <div className={styles.whatHappened} data-testid="what-happened">
      <TextAreaPage
        buttonText="Next"
        defaultValue={description}
        descriptiveText={descriptiveText}
        handleChange={handleWhatHappenedChange}
        handleSubmit={handleWhatHappenedSubmit}
        imgObj={imgObj}
        isFocused
        isInputValid={WhatHappenedTextAreaValid}
        maxChars={2500}
        placeholderText={placeholderText}
        ref={WhatHappenedTextAreaRef}
        title={title}
      />
    </div>
  )
}
